import { render, staticRenderFns } from "./CotizadorAcciones.vue?vue&type=template&id=021becb4&"
import script from "./CotizadorAcciones.vue?vue&type=script&lang=js&"
export * from "./CotizadorAcciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports